// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import {
  ToggleFavorite,
  useFavorite,
} from '@bottlebooks/gatsby-plugin-bookmarks/src';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import {
  hasDifferentExhibitor,
  ProductHeaderDetails,
  ProductHeaderDetailsFragment,
  ProductName,
  ProductNameFragment,
  ProductProducer,
  ProductProducerNameFragment,
  ProductStand,
  ProductStandFragment,
} from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductHeader';
import ProductLabel from '@bottlebooks/gatsby-theme-event/src/components/Product/ProductLabel';
import ProductImageCol, {
  ProductImageFragment_large,
} from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductImageCol';
import ProductNavigation from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductNavigation';
import {
  ProductMainCol,
  ProductPageHeaderRow,
} from '@bottlebooks/gatsby-theme-event/src/components/ProductPage/ProductPageHeader';
import ExhibitorStand from '../Exhibitor/ExhibitorStand';
export * from '@bottlebooks/gatsby-theme-event/src/components/EventProductPage/EventProductPageHeader';

export default function EventProductPageHeader({
  product,
  next,
  previous,
  standPath,
  overlapImage,
}) {
  const link = useLink();
  const favorite = useFavorite(
    product && { type: 'product', id: product.productId }
  );
  const hasOtherExhibitor = hasDifferentExhibitor(product);
  return (
    <ProductPageHeaderRow sx={{ justifyContent: 'center' }}>
      <ProductImageCol product={product} overlap={overlapImage} />
      <ProductMainCol>
        <ProductLabel product={product} sx={{ marginBottom: 3.5 }} />
        <ExhibitorStand exhibitor={product} />
        <ProductProducer
          producer={product?.producer}
          to={link.producer(product.producer)}
        />
        <ProductName as="h1" product={product} />
        <ProductHeaderDetails product={product} showMorePricingInfo={true} />
        <ToggleFavorite
          sx={{ marginTop: 3, marginLeft: -2, padding: 0, paddingRight: 3 }}
          isToggled={favorite.isSet}
          onClick={favorite.toggle}
        />
      </ProductMainCol>

      <ProductNavigation previous={previous} next={next} />
    </ProductPageHeaderRow>
  );
}
